/**
 * Müşteri Genel Toplam (Net) / Beklenen Gelir hesabı.
 * OrderDetails.js toplamOdeme + manualTotalOverride mantığı ile uyumludur.
 * Hiyerarşi: Manuel Override > Vade Farkı > Genel İskonto > Ürün İndirimi > Ara Toplam
 */
export const calculateCustomerGrandTotal = (customer, orders = []) => {
  if (customer?.manualTotalOverride != null && customer.manualTotalOverride !== '') {
    return parseFloat(customer.manualTotalOverride);
  }

  if (!Array.isArray(orders) || orders.length === 0) {
    return 0;
  }

  const totalAmount = orders.reduce((sum, order) => {
    return sum + parseFloat(order.totalPrice || 0);
  }, 0);

  const discountedTotalAmount = orders.reduce((sum, order) => {
    if (order.discountedPrice && parseFloat(order.discount) > 0) {
      return sum + parseFloat(order.discountedPrice || 0);
    }
    return sum + parseFloat(order.totalPrice || 0);
  }, 0);

  const vadeliYuzde = parseFloat(customer?.vadeliYuzde) || 0;
  const genelIskontoYuzde = parseFloat(customer?.genelIskontoYuzde) || 0;

  if (vadeliYuzde > 0) {
    return totalAmount + (totalAmount * vadeliYuzde / 100);
  }
  if (genelIskontoYuzde > 0) {
    return totalAmount - (totalAmount * genelIskontoYuzde / 100);
  }
  if (discountedTotalAmount !== totalAmount && discountedTotalAmount > 0) {
    return discountedTotalAmount;
  }
  return totalAmount;
};

export const calculateCustomerRemainingAmount = (customer, orders = []) => {
  if (customer?.isPaymentCompleted) {
    return 0;
  }

  if (!Array.isArray(orders) || orders.length === 0) {
    return -1;
  }

  const paid = parseFloat(customer?.paidAmount) || 0;
  const grandTotal = calculateCustomerGrandTotal(customer, orders);
  return Math.max(0, grandTotal - paid);
};
